/* created by CoolGuy on 2018/12/13 */
import { observable, action } from "mobx";
import redpackApi from "../actions/redpack";
import RootStore from "./RootStore";
import { IRedPack, IPreCreate, ICreate } from "./RedPackStore.d";
import { IResult } from "../global.d";
import { History } from "history";
import intl from "react-intl-universal";
import stat from "../utils/stat";
import moment from "moment";

export default class RedPackStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
  }

  @observable showRedPackDetailModal = false; // 是否显示红包详情
  @observable redPackDetailId = 0;

  @observable showVerifyModal = false;
  @observable verifyModalContent = {};

  @action setRedPackDetailModal = (detailId: number, flag?: boolean) => {
    this.redPackDetailId = detailId;
    this.showRedPackDetailModal =
      typeof flag === "boolean" ? flag : !this.showRedPackDetailModal;

    this.removeAllRedPackList();
  };

  @action setVerifyModal = (flag?: boolean) => {
    this.showVerifyModal =
      typeof flag === "boolean" ? flag : !this.showVerifyModal;
  };
  @action setVerifyModalContent = (content: any) => {
    this.verifyModalContent = content;
  };

  @observable showNotification = false;
  @action setNotification = (flag?: boolean) => {
    this.showNotification =
      typeof flag === "boolean" ? flag : !this.showNotification;
  };

  @observable showSendModal = false;
  @action setSendModal = (flag?: boolean) => {
    this.showSendModal = typeof flag === "boolean" ? flag : !this.showSendModal;
  };
  sendSms = (phone: string, type = "login") => {
    return redpackApi.sendsms({ phone, type });
  };
  bindPhone = (obj: any) => {
    return redpackApi.bindphone(obj);
  };
  @observable redPackList = [] as IRedPack[];
  // 对于一些不方便拿到galleryid的，直接用第一次获取时的galleryid
  currentGalleryId = "";
  getDetail = (galleryid: string | undefined) => {
    if (!galleryid) {
      galleryid = this.currentGalleryId;
    }
    this.currentGalleryId = galleryid;
    if (!this.rootStore.wxuserStore.user.is_mock) {
      return redpackApi.getdetail(galleryid).then(
        action((jsonData: any) => {
          const list = jsonData || [];
          this.redPackList = list.filter((one: any) => {
            return !this.gotRedPackList().includes(one.id);
          });
          // console.log(this.redPackList.length);
          return jsonData;
        })
      );
    }
    return [];
  };
  @action removeOneRedPackList = (index = 0) => {
    const { length } = this.redPackList;
    if (index > length) {
      return;
    }
    this.redPackList = [
      ...this.redPackList.slice(0, index),
      ...this.redPackList.slice(index + 1),
    ];
  };
  @action addOneRedPack = ({
    content,
    postname,
    postphoto,
    id,
    posttype = "now",
  }: IRedPack) => {
    this.redPackList.push({ content, postname, postphoto, id, posttype });
  };
  @action setRedPackList = ([
    { content, postname, postphoto, id, posttype = "now" },
  ]: IRedPack[]) => {
    this.redPackList = [{ content, postname, postphoto, id, posttype }];
  };
  @action removeAllRedPackList = () => {
    this.redPackList = [];
  };
  @observable currentServerTime = 0;
  getServerTime = () => {
    return redpackApi.gettime().then(
      action((jsonData: IResult) => {
        const { timestamp } = jsonData;
        this.currentServerTime = timestamp;
        return timestamp;
      })
    );
  };
  @action setServerTime = (time: string) => {
    this.currentServerTime = moment(time).valueOf();
  };
  getRedPack = (id: number) => {
    return redpackApi.getredpack(id);
  };
  @observable notificationTime = 0;
  @action setNotificationTime = (time: number, useServerTime: boolean) => {
    this.notificationTime = time - (useServerTime ? this.currentServerTime : 0);
    this.setNotification(true);
  };
  askRedPack = (id: number) => {
    stat.event("event_redbag");

    // 是不是要判断一下呀
    let list = this.gotRedPackList();
    if (list && list.length) {
      if (list.indexOf(String(id)) > -1) {
        return new Promise((resolve) => {
          resolve({
            access_type: "all",
            status: "done",
          });
        }) as PromiseLike<IResult>;
      }
    }

    return redpackApi.askredpack(id);
  };
  askNGot = () => {
    const { uiStore } = this.rootStore;
    const { redPackList = [], askRedPack } = this;
    const one = redPackList[0];
    askRedPack(one.id).then((data: IResult) => {
      //console.log(data);
      const { status } = data;
      // done  代表已领取过
      // forbidden 代表不可领取，包括：不在白名单，或者红包活动异常等情况
      // welcome 代表可领取
      switch (status) {
        case "welcome":
          this.getTheRedPack();
          break;
        case "wait":
          uiStore.showAlert(intl.get("Red packet status exception"));
          break;
        // eslint-disable-next-line no-fallthrough
        case "forbidden":
          uiStore.showAlert(intl.get("Current red packet can't be open"));
          this.saveToGotRedPackList(one.id);
          break;
        case "done":
        // 下同
        // eslint-disable-next-line no-fallthrough
        case "end":
        // 下同
        // eslint-disable-next-line no-fallthrough
        default:
          // 因为某种情况反正已经领取了，直接就存进去了
          this.saveToGotRedPackList(one.id);
          this.setRedPackDetailModal(one.id);
          break;
      }
    });
  };
  getTheRedPack = () => {
    const { uiStore } = this.rootStore;
    const { redPackList = [], getRedPack } = this;
    const one = redPackList[0];
    uiStore.showToast({
      time: 0,
      content: intl.get("Redpack Opening"),
    });
    getRedPack(one.id).then(() => {
      uiStore.hideToast();
      uiStore.showToast({ time: 500, content: intl.get("Open succeed") });
      this.saveToGotRedPackList(one.id);
      setTimeout(() => {
        this.setRedPackDetailModal(one.id);
        this.removeOneRedPackList();
      }, 500);
    });
  };
  // 本地存储的已经领取的红包列表
  gotRedPackList = () => {
    const list = localStorage["gotRedPackList"];
    let jList;
    try {
      jList = JSON.parse(list);
    } catch (e) {
      jList = [];
    }
    return jList;
  };

  saveToGotRedPackList = (id: number) => {
    // localStorage['gotRedPackListTime'] 是最近一次已经点击的红包的时间
    const lastTime = localStorage["gotRedPackListTime"] || 0;
    const now = new Date().getTime();
    // 如果最后一次存入列表时间长于30天，清空列表
    if (now - lastTime > 30 * 24 * 3600 * 1000) {
      delete localStorage["gotRedPackList"];
    }
    localStorage["gotRedPackListTime"] = now;
    const list = this.gotRedPackList();
    // 如果列表已经有这个ID了，那么就不需要存储了
    if (list.includes(id)) {
      return;
    }
    //保证都是字符串，避免一些异常情况
    list.push("" + id);
    localStorage["gotRedPackList"] = JSON.stringify(list);
  };

  getOneRedPackDetail = (id: number, page: number) => {
    this.saveToGotRedPackList(id);
    return redpackApi.getredpackdetail(id, page);
  };

  getLocalLastForShowTime = (galleryId: number) => {
    const id = galleryId || this.currentGalleryId;
    // console.log(id,'getLocalLastForShowTime');
    let theList = null;
    try {
      theList = JSON.parse(localStorage["lastForShowTime"]);
    } catch (e) {
      theList = null;
    }
    if (!Array.isArray(theList)) {
      return "";
    }
    const theOne = theList.find((one) => one.key == id);
    return theOne ? theOne.value : "";
  };
  // time为null表示删除当前项，否则会设定成其值（强制转换成Number）
  setLocalLastForShowTime = (galleryId: number, time: number | null) => {
    const id = galleryId || this.currentGalleryId;
    let theList = [];
    try {
      theList = JSON.parse(localStorage["lastForShowTime"]);
    } catch (e) {}
    if (!theList) {
      theList = [];
    }
    const theIndex = theList.findIndex((one: any) => one.key == id);
    if (theIndex === -1) {
      theList.push({
        key: id,
        value: +(time || 0), //key 都保留是Number
      });
    } else {
      if (time === null) {
        theList.splice(theIndex, 1);
      } else {
        theList[theIndex].value = time;
      }
    }
    localStorage["lastForShowTime"] = JSON.stringify(theList);
  };

  preCreate = ({ amount, galleryid }: IPreCreate) => {
    return redpackApi.precreate({ amount, galleryid });
  };

  create = ({ number, amount, type, content, tradeid, galleryid }: ICreate) => {
    if (!tradeid) {
      console.warn("tradeid is null", tradeid);
      return new Promise((resolve, reject) => reject());
    }
    return redpackApi.create({
      number,
      amount,
      type,
      content,
      tradeid,
      galleryid,
    });
  };

  @action clearAll = () => {
    // this.showNormal = false;
    this.showNotification = false;
    this.notificationTime = 0;
    this.currentServerTime = 0;
    this.redPackList = [];
  };
}
